import React from 'react';

const Disclaimers: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="bg-[#F4B6A1]/10 p-4 rounded-lg mb-6">
        <p className="font-semibold text-gray-800">Important:</p>
        <p>FeelHeard.me provides AI-powered emotional support but makes no guarantees about specific outcomes or results.</p>
      </div>

      <h4 className="text-lg font-semibold mb-2">Service Disclaimers</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Service provided "as is" without warranties</li>
        <li>No guarantee of continuous, uninterrupted service</li>
        <li>AI responses may vary in quality or relevance</li>
        <li>Not responsible for user decisions based on AI interactions</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Limitation of Liability</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Maximum liability limited to subscription fees paid</li>
        <li>No liability for:
          <ul className="list-disc pl-5 mt-2">
            <li>Indirect or consequential damages</li>
            <li>Lost profits or data</li>
            <li>Service interruptions</li>
            <li>Third-party actions</li>
          </ul>
        </li>
      </ul>

      <div className="bg-[#C2A4D6]/10 p-4 rounded-lg mt-6">
        <p className="text-sm text-gray-600">
          Some jurisdictions do not allow the exclusion of certain warranties or limitations 
          of liability, so some of the above limitations may not apply to you.
        </p>
      </div>
    </div>
  );
};

export default Disclaimers;